module.exports = __webpack_public_path__ + "img/dashboard.607fb198.svg";